/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useMemo } from 'react';
import _ from 'lodash';
import { selectActiveCategory, selectProcedureData } from './dashboard.slice';
import { fetchProcedureData } from './dashboard.thunk';
import { useSubsequentActions } from '../../../shared/subsequentActions/useSubsequentActions';
import { RoutePath } from '../../../shared/enums/RoutePath';

export function useDashboardCard({ procedureId }) {
  const dispatch = useDispatch();
  const activeCategory = useSelector(selectActiveCategory);
  const { label, procedureData = [] } = useSelector(state => selectProcedureData(state, procedureId));
  const subsequentActions = useSubsequentActions(procedureId);

  useEffect(() => {
    if (procedureId) {
      dispatch(
        fetchProcedureData({
          procedureId,
          subsequentActionsLabel: 'submission.subsequent-actions.label',
        }),
      );
    }
  }, [procedureId, activeCategory, dispatch]);

  // calculate the sum from an object of objects
  const total = useMemo(() => _.sum(procedureData.map(status => status.total)), [procedureData]);

  return {
    label,
    total,
    navigationUrl: RoutePath.generateRoutePath(RoutePath.PROCEDURE_SEARCH, { procedure: procedureId }),
    procedureData,
    saEnabled: subsequentActions.enabled,
  };
}
